module.exports = __webpack_public_path__ + "static/media/beauty.4a501830.png";